<template>
  <button
    class="group rounded-xl outline-none transition-all font-medium text-xs md:text-base focus:ring-2 focus:ring-orange-200 focus:ring-offset-2"
    :class="[
        props.disabled ? 'opacity-60' : '',
        theme == 'grey' ? 'bg-[#F1F1F1] text-[#767472]' : 'accent-gradient-bg text-white'
    ]"
    :disabled="props.disabled"
    @click.stop="emit('click', $event)"
  >
    <div class="flex items-center justify-center">
      <slot></slot>
    </div>
  </button>
</template>

<script setup lang="ts">
const props = defineProps<{
  disabled?: boolean
  theme?: string
}>()

const emit = defineEmits<{
  (e: 'click', event: MouseEvent): void
}>()
</script>

<style></style>
